import React from 'react';
import { Mic, MicOff } from 'lucide-react';

/**
 * Microphone push-to-talk button — shows up only when the browser
 * supports SpeechRecognition. Click once to start, click again to stop.
 * Spinner ring pulses while listening.
 */
export default function MicButton({ supported, listening, onStart, onStop, testId, label = 'Voice input' }) {
  if (!supported) return null;
  const Icon = listening ? MicOff : Mic;
  return (
    <button
      type="button"
      onClick={listening ? onStop : onStart}
      data-testid={testId || 'mic-button'}
      aria-pressed={listening}
      aria-label={label}
      title={listening ? 'Stop listening' : 'Start voice input'}
      style={{
        width: '40px',
        height: '40px',
        borderRadius: '12px',
        border: '1px solid',
        borderColor: listening ? '#ef4444' : 'rgba(0, 255, 255, 0.35)',
        background: listening ? 'rgba(239, 68, 68, 0.15)' : 'rgba(0, 255, 255, 0.08)',
        color: listening ? '#ef4444' : '#22d3ee',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'all 160ms ease',
        position: 'relative',
        flexShrink: 0,
      }}
    >
      <Icon className="w-4 h-4" />
      {listening && (
        <span
          aria-hidden="true"
          style={{
            position: 'absolute',
            inset: '-3px',
            border: '2px solid #ef4444',
            borderRadius: '14px',
            animation: 'mic-pulse 1.2s ease-in-out infinite',
          }}
        />
      )}
      <style>{`
        @keyframes mic-pulse {
          0%, 100% { opacity: 0.7; transform: scale(1); }
          50%      { opacity: 0.1; transform: scale(1.15); }
        }
      `}</style>
    </button>
  );
}
